import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop } from "lodash";
import { Input, Select, InputDate, Textarea } from "../../../components/base/index";
import { GENDER } from "../../../variables/common.variable";
import {
  commaFormatted,
  normalizeAmount,
  manageGetRegistration,
} from "../../../utils/transformer.util";

export default class OrtuWaliForm extends Component {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._filterOptions = this._filterOptions.bind(this);
    this.state = {
      original: {
        sub_districts: props.sub_districts || [],
        districts: props.districts || [],
        cities: props.cities || [],
        provinces: props.provinces || [],
      },
      options: {
        sub_districts: [],
        districts: [],
        cities: [],
        provinces: [],
      },
    };
  }

  // componentDidUpdate({
  //   provinces: prevP,
  //   cities: prevC,
  //   sub_districts: prevS,
  //   districts: prevD,
  // }) {
  //   const {
  //     provinces = [],
  //     cities = [],
  //     sub_districts = [],
  //     districts = [],
  //   } = this.props;
  //   if (
  //     JSON.stringify(provinces) !== JSON.stringify(prevP) ||
  //     JSON.stringify(cities) !== JSON.stringify(prevC) ||
  //     JSON.stringify(districts) !== JSON.stringify(prevD) ||
  //     JSON.stringify(sub_districts) !== JSON.stringify(prevS)
  //   ) {
  //     this.setState({
  //       original: {
  //         provinces,
  //         cities,
  //         districts,
  //         sub_districts,
  //       },
  //       options: {
  //         provinces,
  //         cities,
  //         districts,
  //         sub_districts,
  //       },
  //     });
  //   }
  // }

  _onFormChange(e) {
    const { onChange } = this.props;
    let change = {};
    change[e.target.name] = e.target.value;
    this.setState(change, () => {
      console.log(this.state);
    });

    onChange(e);
  }

  _filterOptions(name) {
    const { original } = this.state;
    const { form = {} } = this.props;
    const { value = {} } = form;

    if (name === "cities") {
      return original.cities.filter(
        (o) => o.data.provinces_id == value.guardian_provincess_id
      );
    } else if (name === "districts") {
      return original.districts.filter(
        (o) => o.data.cities_id == value.guardian_city_id
      );
    } else if (name === "sub_districts") {
      return original.sub_districts.filter(
        (o) => o.data.districts_id == value.guardian_districts_id
      );
    } else {
      return original.provinces;
    }
  }

  render() {
    const { options, original } = this.state;
    const { provinces, sub_districts, districts, cities } = options;
    const { form, idx, onChange, classes, param, param2 } = this.props;

    if (form.value.guardian_provincess_id == "") {
      form.value.guardian_city_id = "";
    }
    if (form.value.guardian_city_id == "") {
      form.value.guardian_districts_id = "";
    }
    if (form.value.guardian_districts_id == "") {
      form.value.guardian_sub_districts_id = "";
    }

    return (
      <div className="manage-registration__custom-form">
        <h1>Wali</h1>

        <div className="manage-registration__custom-form-row">
          <div className="manage-registration__custom-form-row__field">
            <Input
              type="text"
              name="guardian_name"
              label="Nama Lengkap*"
              onChange={this._onFormChange}
              value={form.value.guardian_name}
              error={form.error.guardian_name || ""}
              isRequired
            />
          </div>
          <div className="manage-registration__custom-form-column__field">
            <Input
              type="number"
              name="guardian_nik"
              label="NIK*"
              onChange={this._onFormChange}
              value={form.value.guardian_nik}
              error={form.error.guardian_nik || ""}
              onInput={(e) => e.target.value = e.target.value.slice(0, 16)}
              isRequired
            />
          </div>
        </div>

        <div className="manage-registration__custom-form-row">
          <div className="manage-registration__custom-form-row__field">
            <Select
              name="guardian_religions_id"
              label="Agama"
              onChange={this._onFormChange}
              placeholder="Pilihan"
              value={form.value.guardian_religions_id}
              error={form.error.guardian_religions_id || ""}
              data={param.religions}
              // isRequired
            />
          </div>
          <div className="manage-registration__custom-form-column__field">
            <Select
              name="guardian_citizenships_id"
              label="Kewarganegaraan"
              onChange={this._onFormChange}
              placeholder="Pilihan"
              value={form.value.guardian_citizenships_id}
              error={form.error.guardian_citizenships_id || ""}
              data={param.citizenships}
              // isRequired
            />
          </div>
        </div>

        <div className="manage-registration__custom-form-row">
          <div className="manage-registration__custom-form-row__field">
            <Select
              name="guardian_educations_id"
              label="Pendidikan Terakhir"
              onChange={this._onFormChange}
              placeholder="Pilihan"
              value={form.value.guardian_educations_id}
              error={form.error.guardian_educations_id || ""}
              data={param.educations}
              // isRequired
            />
          </div>
          <div className="manage-registration__custom-form-row-input__field">
            <Input
              type="text"
              name="guardian_pob"
              label="Tempat Tanggal Lahir*"
              onChange={this._onFormChange}
              value={form.value.guardian_pob}
              error={form.error.guardian_pob || ""}
              isRequired
            />
            <div className="manage-registration__custom-form-margin-left">
              <InputDate
                type="date"
                name="guardian_dob"
                label="Tanggal"
                onChange={this._onFormChange}
                value={form.value.guardian_dob}
                error={form.error.guardian_dob || ""}
                // isRequired
              />
            </div>
          </div>
        </div>

        <div className="manage-registration__custom-form-row">
          <div className="manage-registration__custom-form-row__field">
            {/* <Input
            name="jabatanayah"
            label="Jabatan"
            onChange={this._onFormChange}
            value={form.value.jabatanayah}
          />*/}
          </div>

          <div className="manage-registration__custom-form-column__field">
            {/* <Input
            type='nominal'
            name="penghasilanibu"
            label="Penghasilan"
            onChange={this._onFormChange}
            value={form.value.penghasilanibu}
          />*/}
          </div>
        </div>

        <div className="manage-registration__custom-form-row">
          <div className="manage-registration__custom-form-row__field">
            <Input
              type="text"
              name="guardian_phone"
              label="No Telpon*"
              onChange={this._onFormChange}
              value={form.value.guardian_phone}
              error={form.error.guardian_phone || ""}
              isRequired
            />
          </div>
          <div className="manage-registration__custom-form-row__field">
            <Select
              name="guardian_occupations_id"
              label="Pekerjaan"
              onChange={this._onFormChange}
              data={param.occupations}
              placeholder="Pilihan"
              value={form.value.guardian_occupations_id}
              error={form.error.guardian_occupations_id || ""}
              // isRequired
            />
          </div>
        </div>

        <div className="manage-registration__custom-form-row">
          <div className="manage-registration__custom-form-row__field">
            <Input
              name="guardian_position"
              label="Jabatan"
              onChange={this._onFormChange}
              value={form.value.guardian_position}
              error={form.error.guardian_position || ""}
              isRequired
            />
          </div>

          <div className="manage-registration__custom-form-column__field">
            <Input
              type="nominal"
              name="guardian_salary"
              label="Penghasilan*"
              onChange={this._onFormChange}
              value={form.value.guardian_salary}
              error={form.error.guardian_salary || ""}
              isRequired
            />
          </div>
        </div>

        <div className="manage-registration__custom-form-row">
          <Textarea
            type="text"
            name="guardian_address"
            label="Alamat Tempat Tinggal*"
            onChange={this._onFormChange}
            value={form.value.guardian_address}
            error={form.error.guardian_address || ""}
            isRequired
          />
        </div>

        <div className="manage-registration__custom-form-row">
          <div className="manage-registration__custom-form-row__field">
            <Input
              name="guardian_status"
              label="Status/Kondisi"
              onChange={this._onFormChange}
              value={form.value.guardian_status}
              error={form.error.guardian_status || ""}
            />
          </div>
          <div className="manage-registration__custom-form-column__field">
            <Input
              name="guardian_provincess_id"
              value={form.value.guardian_provincess_id}
              error={form.error.guardian_provincess_id || ""}
              placeholder="Pilihan"
              // data={this._filterOptions("provinces")}
              label="Propinsi"
              onChange={this._onFormChange}
            />
            {/* {console.log(form.value.provinces)} */}
          </div>
        </div>

        {form.value.guardian_provincess_id ? (
          <div>
            <div className="manage-registration__custom-form-row">
              <div className="manage-registration__custom-form-row__field">
                <Input
                  name="guardian_city_id"
                  label="Kabupaten/Kota"
                  onChange={this._onFormChange}
                  placeholder="Pilihan"
                  value={form.value.guardian_city_id}
                  error={form.error.guardian_city_id || ""}
                  // data={this._filterOptions("cities")}
                />
              </div>

              <div className="manage-registration__custom-form-column__field"></div>
            </div>
            {form.value.guardian_city_id ? (
              <div className="manage-registration__custom-form-row">
                <div className="manage-registration__custom-form-row__field"></div>

                <div className="manage-registration__custom-form-column-city__field">
                  <Input
                    name="guardian_districts_id"
                    label="Kecamatan"
                    onChange={this._onFormChange}
                    // data={this._filterOptions("districts")}
                    placeholder="Pilihan"
                    value={form.value.guardian_districts_id}
                    error={form.error.guardian_districts_id || ""}
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            {form.value.guardian_districts_id ? (
              <div className="manage-registration__custom-form-row">
                <div className="manage-registration__custom-form-row__field">
                  <Input
                    name="guardian_sub_districts_id"
                    label="Kelurahan"
                    onChange={this._onFormChange}
                    // data={this._filterOptions("sub_districts")}
                    placeholder="Pilihan"
                    value={form.value.guardian_sub_districts_id}
                    error={form.error.guardian_sub_districts_id || ""}
                  />
                </div>
                <div className="manage-registration__custom-form-row__field">
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
OrtuWaliForm.propTypes = {
  //   onFormChange: PropTypes.func,
  idx: PropTypes.number.isRequired,
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  list: PropTypes.array.isRequired,
  provinces5: PropTypes.array,
  cities5: PropTypes.array,
  districts5: PropTypes.array,
  sub_districts5: PropTypes.array,
  classes: PropTypes.array,
  religions: PropTypes.array,
  citizenships: PropTypes.array,
  educations: PropTypes.array,
  occupations: PropTypes.array,
};
OrtuWaliForm.defaultProps = {
  //   onFormChange: noop,
  onChange: noop,
  provinces5: [],
  cities5: [],
  districts5: [],
  guardian_city_id: [],
  guardian_districts_id: [],
  sub_districts5: [],
  religions: [],
  citizenships: [],
  classes: [],
  educations: [],
  occupations: [],
};